import classNames from "classnames";
import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { ReactNode, useState } from "react";

type ChipProps = {
  children: ReactNode;
  icon: ReactNode;
  isActive?: boolean;
  onClose: () => void;
  onClick: () => void;
};

export const ProductChip = ({
  children,
  icon,
  isActive = false,
  onClose,
  onClick: onClickFromProps,
}: ChipProps) => {
  const onRemove = () => {
    onClose();
  };

  const onClick = () => {
    if (isActive) {
      onRemove();
    } else {
      onClickFromProps();
    }
  };

  return (
    <button
      onClick={onClick}
      className={classNames(
        "all:unset t-flex t-gap-1.5 t-items-center t-text-body-sm t-text-text-60 t-border t-border-solid t-border-neutral-0 t-w-max t-px-3 hover:t-border-purple-20 hover:t-bg-purple-0 t-select-none t-rounded-md t-h-7",
        {
          "!t-border-purple-40 !t-bg-purple-0 has-[.close-button:hover]:!t-bg-red-10 has-[.close-button:hover]:!t-border-red-30":
            isActive,
          "!t-border-surface-transparent !t-bg-surface-grey": !isActive,
        }
      )}
    >
      {icon}
      {children}
      {isActive && (
        <span className="close-button">
          <Button onClick={onRemove} customType="ghost_icon" size="xxsmall">
            <Cross size="12" color="currentColor" />
          </Button>
        </span>
      )}
    </button>
  );
};
